// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Pagination_arrow__i_7te","icon":"Pagination_icon__0hmjt","button":"Pagination_button__xlZ3f"};